export const fireUserSignInEvent = (sourceOfRequest: string) => {
  const event = document.createEvent("Event") as any;
  event.data = sourceOfRequest;
  event.initEvent("user_sign_in", true, true);
  document.body.dispatchEvent(event);
};
